import { Toast } from '@base-ui-components/react/toast';

export const toastManager = Toast.createToastManager();
